import React from 'react';
import PropTypes from 'react-proptypes';
import Button from './button';

export default class MessageBoxButton extends React.Component {
  static propTypes = {
    buttonText: PropTypes.string,
    index: PropTypes.number,
    onClick: PropTypes.func,
  };

  render() {
    return (
      <Button
        text
        onClick={this.handleClick}
      >
        {/* @ts-ignore */}
        {this.props.buttonText}
      </Button>
    );
  }

  handleClick = () => {
    // @ts-ignore
    this.props.onClick(this.props.buttonText, this.props.index);
  };
}
